<template>
  <v-tooltip top open-delay='700'>
    <template v-slot:activator='{ on }'>
      <v-chip
        class='mx-2'
        v-on='on'
        label
        small
        :color="woCount > 0 ? 'error' : 'grey darken-4'"
        dark
        @click="$emit('deselectAll')"
        :disabled='!selectedWOs.length'
      >
        WOs selected: {{ woCount }}
      </v-chip>
    </template>
    <span>Click to clear</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'selected-wos',
  computed: {
    selectedWOs () {
      return this.$store.state.schedule.selectedWOs
    },
    woCount () {
      return this.selectedWOs.length
    }
  }
}

</script>
